// extracted by mini-css-extract-plugin
module.exports = {"variant":"i_De","name":"i_Df","block":"i_Dg","image":"i_Dh"};